import React, { useState, useContext } from 'react';
import { useAuthContext } from 'context/AuthContext';
import localStorageNames from 'data/localStorageNames';

// realm
import * as Realm from 'realm-web';
const REALM_APP_ID =
  process.env[`REACT_APP_REALM_CONFIGURATION_${process.env.REACT_APP_ENV}`];
const CLIENT_TRANSACTION =
  process.env[`REACT_APP_ENDPOINT_CLIENT_TRANSACTION_${process.env.REACT_APP_ENV}`];
const realmApp = new Realm.App({ id: REALM_APP_ID });

export const RealmContext = React.createContext([{}, () => { }]);

const RealmProvider = ({ children }) => {
  const [state, setState] = useState({
    transaction: {},
    realmCredential: {},
  });

  const {
    getCredential,
    getOutletInfo,
    getOutletId,
    hitAPIEC2
  } = useAuthContext();

  const setLocalState = (newData) => {
    setState((prev) => ({
      ...prev,
      ...newData,
    }));
  };

  const getLocalState = (key) => {
    if (key) {
      return state[key];
    }
    return state;
  };

  const loginRealm = async () => {
    try {
      if (getCredential() && getOutletId()) {
        const credentials = Realm.Credentials.function({
          outlet_id: getOutletId(),
        });
        const user = await realmApp.logIn(credentials);
        setLocalState({ realmCredential: user });

        return user;
      }
    } catch (e) {
      console.error(e);
    }
  };

  const getTransactionsId = () => {
    return JSON.parse(localStorage.getItem(localStorageNames.TRANSACTIONS_ID));
  };

  const saveTransactionsId = async (transactionId) => {
    let tempTransactionsId = [];
    if (getTransactionsId()) {
      tempTransactionsId = getTransactionsId();
    }
    tempTransactionsId.push(transactionId);
    localStorage.setItem(
      localStorageNames.TRANSACTIONS_ID,
      JSON.stringify(tempTransactionsId),
    );
  };

  const hitRealmTransaction = async (payloadData) => {
    const payload = {
      method: 'POST',
      data: {
        ...payloadData,
      },
    }
    const result = await hitAPIEC2(CLIENT_TRANSACTION, 'POST', payload, true);
    // let user = await loginRealm();
    // const result = await user.callFunction('clientTransaction', {
    //   method: 'POST',
    //   data: {
    //     ...payloadData,
    //   },
    // });
    // result transactionId
    await saveTransactionsId(result);
    return result;
  };

  const queryTransaction = async (filter) => {
    let outletInfo = JSON.parse(getOutletInfo());
    if (getCredential() && outletInfo) {
      await loginRealm();

      const mongodb = realmApp.currentUser.mongoClient('mongodb-atlas');

      const transCollection = mongodb.db('RDO').collection('transactions');
      let rawData = await transCollection.aggregate([
        { $match: { ...filter, table_id: outletInfo.tableId } },
        {
          $lookup: {
            from: 'transaction_items',
            let: { tItems: '$transaction_items' },
            pipeline: [
              {
                $match: {
                  $expr: { $in: ['$_id', { $ifNull: ['$$tItems', []] }] },
                },
              },
              {
                $lookup: {
                  from: 'transaction_prep_items',
                  localField: 'prep_items',
                  foreignField: '_id',
                  as: 'prep_items',
                },
              },
              {
                $lookup: {
                  from: 'transaction_discounts',
                  localField: 'discounts',
                  foreignField: '_id',
                  as: 'discounts',
                },
              },
            ],
            as: 'transaction_items',
          },
        },
        {
          $lookup: {
            from: 'transaction_taxes',
            localField: 'taxes',
            foreignField: '_id',
            as: 'taxes',
          },
        },
        {
          $lookup: {
            from: 'transaction_discounts',
            localField: 'discounts',
            foreignField: '_id',
            as: 'discounts',
          },
        },
        {
          $project: {
            _id: 1,
            outlet: 1,
            table_id: 1,
            table_name: 1,
            grand_total: 1,
            sub_total: 1,
            status: 1,
            is_split: 1,
            transaction_items: {
              _id: 1,
              plu_number: 1,
              plu_name: 1,
              amount: 1,
              quantity: 1,
              sales_type: 1,
              note: 1,
              type: 1,
              prep_items: 1,
              discounts: {
                _id: 1,
                amount: 1,
                discount_name: 1,
                discount_percent: 1,
                functionId: 1,
                type: 1,
              },
            },
            taxes: {
              _id: 1,
              title: 1,
              value: 1,
              TTax: 1,
            },
            discounts: {
              _id: 1,
              amount: 1,
              discount_name: 1,
              discount_percent: 1,
              functionId: 1,
              type: 1,
            },
          },
        },
      ]);
      return rawData;
    }
  };

  return (
    <RealmContext.Provider
      value={{
        getLocalState,
        setLocalState,
        hitRealmTransaction,
        queryTransaction,
        getTransactionsId,
        saveTransactionsId,
      }}>
      {children}
    </RealmContext.Provider>
  );
};

export const useRealmContext = () => {
  const value = useContext(RealmContext);
  if (value == null) {
    throw new Error('useCartContext() called outside of a Provider?');
  }
  return value;
};

export default RealmProvider;
